import { Supplier } from '../types/utility.types';
import axios from './axiosConfig';

interface ApiResponse<T> {
  data: T;
}

export const fetchSuppliers = async (): Promise<Supplier[]> => {
  try {
    console.log('API: Fetching suppliers from /suppliers');
    const response = await axios.get<ApiResponse<Supplier[]>>('/suppliers');
    console.log('API: Suppliers response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('API: Error fetching suppliers:', error);
    throw error;
  }
};

export const createSupplier = async (supplierData: Omit<Supplier, '_id'>): Promise<Supplier> => {
  try {
    const response = await axios.post<ApiResponse<Supplier>>('/suppliers', supplierData);
    return response.data.data;
  } catch (error) {
    
    throw error;
  }
};

export const updateSupplier = async (id: string, supplierData: Partial<Supplier>): Promise<Supplier> => {
  try {
    const response = await axios.put<ApiResponse<Supplier>>(`/suppliers/${id}`, supplierData);
    return response.data.data;
  } catch (error) {
    
    throw error;
  }
};

export const deleteSupplier = async (id: string): Promise<void> => {
  try {
    await axios.delete(`/suppliers/${id}`);
  } catch (error) {
    
    throw error;
  }
};
